module.exports = __webpack_public_path__ + "static/og-image2-c737a50ae8b1b2a0c340c0973e99ded2.png";